<div class='ContentInfoMobileRow mobile-row d-flex'>
  <div class='ContentInfoMobileRow--left mobile-row-section flex-grow-1'>{{ item.content_name }}</div>
  <div class='ContentInfoMobileRow--left mobile-row-section flex-grow-1'>{{ item.content_goal }}</div>
  <div
    class='ContentInfoMobileRow--left mobile-row-section flex-grow-1'>{{ item.campaign_name || 'No campaign Associated' }}
  </div>
  <div class='ContentInfoMobileRow--right mobile-row-section flex-grow-0'>
    <app-menu-button [properties]='menuItems'
                     [target]='item'></app-menu-button>
  </div>
</div>
